import React, { useEffect } from "react";
import "./LpReviews.css";
import LpReviewsHead from "./LpReviewsHead";
const LpReviews = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://apps.elfsight.com/p/platform.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return (
    <div className="lpReviews-container">
      <LpReviewsHead />
      <div className="reviewsContainer">
        <div className="reviewsContent">
          <iframe
            src="https://widgets.sociablekit.com/google-reviews/iframe/25569316"
            frameborder="0"
            width="100%"
            height="1000"
            title="review"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default LpReviews;
